class BusinessNameVm {
    openHistoryWindow(customerId) {
        window.open(window.location.origin + `/timeline?customerId=${customerId}`, `timeline${customerId}`, `width=680, height=900, toolbar=0,location=0,menubar=0`);
    }
    openHomeWindow(customerId) {
        window.open(window.location.origin + `/customer/detail?customerId=${customerId}`, `home${customerId}`, `width=1140, height=${window.screen.height}, toolbar=0,location=0,menubar=0`);
    }
}
export default new BusinessNameVm();